const FINAL_HOSTS = ['smmclone.com', 'www.smmclone.com', 'my.smmclone.com'];
export const isFinalPlatformHost = (host) => FINAL_HOSTS.includes(host.toLowerCase());
export const platformUrl = (host = typeof window !== 'undefined' ? window.location.hostname : '') =>
  isFinalPlatformHost(host) ? 'https://my.smmclone.com' : 'https://my.smmclone.com';
